import { default as customer } from './customer/store' 
import { default as customerContract } from './contract/store'
import { default as customerContact } from './contact/store'
import { default as customerContractStatus } from './contract-status/store'

export default { 
	customer,
	customerContract,
	customerContact,
	customerContractStatus
}
